import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorCodeUtils } from '../utils/ErrorCodeUtils';
import ErrorCode from "../enums/ErrorCode";
import { UserAreaMappingTypeEnum } from "../enums/rights/user-area-mapping-type.enum";

export class ErrorHandler {


  constructor(private translate: TranslateService) {}

  // region Error Handling
  createErrorMessage (error: HttpErrorResponse): string {
    const translation = ErrorCodeUtils.getErrorMessage(error.error.errorCode);
    let message = translation ? this.translate.instant(translation) : null;
    if (message) {
      //extra rights logic
      const rightsText = this.getTheCorrectRightsErrorMessage(error.error);
      if (rightsText?.length > 0) {
        message = rightsText;
      }
      return message;
    }
  }

  private getTheCorrectRightsErrorMessage(error: any) : string {
    const errorCode = error.errorCode;
    const missingSourceType = error.missingSourceType;
    let text = "";
    switch (errorCode) {
      case ErrorCode.OBJECT_VALIDATION_CLASS_NOT_IN_PRIO_CLASS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.OBJECT_VALIDATION_CLASS_NOT_IN_PRIO_CLASS',
          {dataId: error.dataId}
        );
      case ErrorCode.MISSING_USER_PRIVILEGE:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_USER_PRIVILEGE',
          {privilegeId: error.privilegeId});
      case ErrorCode.MISSING_ORG_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_ORG_ACCESS',
          {dataId: error.dataId});
      case ErrorCode.MISSING_LOCATION_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_LOCATION_ACCESS',
          {dataId: error.dataId});
      case ErrorCode.MISSING_CLASS_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_CLASS_ACCESS',
          {dataId: error.dataId});
      case ErrorCode.MISSING_OBJECT_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_OBJECT_ACCESS',
          {dataId: error.dataId});
      case ErrorCode.MISSING_MODULE_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_MODULE_ACCESS',
          {dataId: error.dataId});
      case ErrorCode.MISSING_SP_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_SP_ACCESS_DUE_NO_ORG_ACCESS',
          {additionalDataId: error.additionalDataId, dataId: error.dataId});
      case ErrorCode.MISSING_WG_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_WG_ACCESS_DUE_NO_ORG_ACCESS',
          {additionalDataId: error.additionalDataId, dataId: error.dataId});
      case ErrorCode.MISSING_PRODUCER_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_PRODUCER_DUE_NO_ORG_ACCESS',
          {additionalDataId: error.additionalDataId, dataId: error.dataId});
      case ErrorCode.MISSING_JOB_ACCESS:
        switch (missingSourceType) {
          case UserAreaMappingTypeEnum.OBJECT:
            text = this.translate.instant(
              'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_JOB_ACCESS_DUE_NO_OBJECT_ACCESS',
              {additionalDataId: error.additionalDataId, dataId: error.dataId});
            break;
          case UserAreaMappingTypeEnum.COMPONENT_CLASS:
            text = this.translate.instant(
              'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_JOB_ACCESS_DUE_NO_CLASS_ACCESS',
              {additionalDataId: error.additionalDataId, dataId: error.dataId});
            break;
        }
        return text;
      case ErrorCode.MISSING_MESSAGE_ACCESS:
        switch (missingSourceType) {
          case UserAreaMappingTypeEnum.OBJECT:
            text = this.translate.instant(
              'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_MESSAGE_ACCESS_DUE_NO_OBJECT_ACCESS',
              {additionalDataId: error.additionalDataId, dataId: error.dataId});
            break;
          case UserAreaMappingTypeEnum.COMPONENT_CLASS:
            text = this.translate.instant(
              'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_MESSAGE_ACCESS_DUE_NO_CLASS_ACCESS',
              {additionalDataId: error.additionalDataId, dataId: error.dataId});
            break;
        }
        return text;
      case ErrorCode.MISSING_COMMUNITY_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_COMMUNITY_ACCESS',
          {dataId: error.dataId});
      case ErrorCode.MISSING_USER_ACCESS:
        return this.translate.instant(
          'DESIGN_B.MESSAGE_TEXTS.ERROR.MISSING_USER_ACCESS_DUE_NO_ORG_ACCESS',
          {additionalDataId: error.additionalDataId, dataId: error.dataId});
      case ErrorCode.MISSING_JOB_TEMPLATE_ACCESS:
      case ErrorCode.MISSING_JOB_ROUTINE_ACCESS:
        return null;
      default:
        return null;
    }
  }
  // endregion
}
